module.exports = __webpack_public_path__ + "static/img/DownloadOnlineSumit.7dd06946.png";